
import { defineComponent, onMounted, reactive, toRefs, computed } from "vue";
import ApiLogistics from "@/request/apis/api_logistics";
import StorageUtil from "@/utils/storage_util";
import ImageView from "@/components/ImageView.vue";
import DriverSet from "@/components/DriverSet.vue";
import PageUtil from "@/utils/page_util";
import { IDriverItem, IEditDriver } from "@/models/logistics_member";
import { amountFormat } from "@/utils/common";
interface IState {
  list: IDriverItem[];
  total: number;
  loading: boolean;
  searches: any;
  visible: boolean;
  editItem?: IEditDriver;
}

// 表格
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "司机姓名",
    dataIndex: "courier",
    key: "courier",
  },
  {
    title: "街道名称",
    dataIndex: "street_name",
    key: "street_name",
  },
  {
    title: "图片",
    dataIndex: "images",
    key: "images",
  },
  {
    title: "类型",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "创建时间",
    dataIndex: "create_time",
    key: "create_time",
    align: "right",
  },
  {
    title: "更新时间",
    dataIndex: "update_time",
    key: "update_time",
    align: "right",
  },
];

export default defineComponent({
  name: "DriverList",
  components: { ImageView, DriverSet },
  setup() {
    const state: IState = reactive({
      list: [],
      total: 0,
      loading: false,
      editItem: undefined,
      visible: false,
      searches: {
        page_no: PageUtil.pageNo,
        page_size: PageUtil.pageSize,
      },
    });

    const pagination = computed(() => ({
      total: state.total,
      current: state.searches.page_no,
      pageSize: state.searches.page_size,
      showTotal: (total: any) => `共${total}条数据`,
      defaultPageSize: 10,
      // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
      showSizeChanger: true, // 是否显示pageSize选择
      showQuickJumper: true, // 是否显示跳转窗
    }));

    // 列表当前页更改
    const handleTableChange = (pages: any) => {
      state.searches.page_size = pages.pageSize;
      state.searches.page_no = pages.current;
      getList();
    };

    //获取列表
    const getList = async () => {
      let params = { ...state.searches };
      StorageUtil.setParams(params);
      state.loading = true;
      const res = await ApiLogistics.reportList(params);
      state.loading = false;
      if (res && res.error_code === 0) {
        const data: any = res.data;
        state.total = data.count;
        state.list = data.list;
      }
    };

    // 初始化search参数
    const initSearch = () => {
      const res = StorageUtil.getParams();
      if (res) {
        state.searches = { ...state.searches, ...res };
      }
    };

    onMounted(() => {
      initSearch();
      getList();
    });

    return {
      ...toRefs(state),
      columns,
      pagination,
      handleTableChange,
      amountFormat,
    };
  },
});
